import { useLayoutEffect, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  // useLayoutEffect runs synchronously after all DOM mutations
  useLayoutEffect(() => {
    const scrollToTop = () => {
      // Use the most compatible method first
      if ('scrollTo' in window) {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant'
        });
      }
      
      // Fallback methods
      window.scrollTo(0, 0);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      
      // Additional fallbacks for different scroll containers
      if (document.scrollingElement) {
        document.scrollingElement.scrollTop = 0;
      }
    };

    scrollToTop();
  }, [pathname]);

  // Additional useEffect as backup
  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    };

    // Small delay to ensure DOM is ready
    const timeoutId = setTimeout(scrollToTop, 10);
    
    return () => clearTimeout(timeoutId);
  }, [pathname]);

  return null;
}